import { ChainName } from "@omnity/widget/src/types";

export const LITEPAPER =
  "https://docs.google.com/document/d/10RSrGfj2Z-LmVhuAXX0Jon-9P9CO6k5ZNfS2hrQB72I/edit?usp=sharing";

export const LINK_HOVER_COLOR = "#E43996";
